import React from 'react';
import ScrollToTop from './common/routing/scollToTop';
import GlobalStyles from './common/styles/globalStyles';
import Root from './common/routing/root';
import './index.css';

const App = () => (
  <ScrollToTop>
    <React.Fragment>
      <GlobalStyles />
      <Root />
    </React.Fragment>
  </ScrollToTop>
);

export default App;
